import { useEffect } from 'react';

const filterRegex = new RegExp(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>|<[^>]*>/gi);
const defaultTitle = document.title.replace(filterRegex, '');

export const useDocumentTitle = (title: string | undefined, prevailOnUnmount = false) => {
  const replaceNonSafeCharacters = /[^a-z0-9\s.()_-]+/gi;

  const filteredTitle = title?.replace(filterRegex, defaultTitle);

  useEffect(() => {
    document.title = `${filteredTitle ?? defaultTitle}`.replace(replaceNonSafeCharacters, ' ');
  }, [filteredTitle, title]);

  useEffect(
    () => () => {
      if (!prevailOnUnmount) {
        document.title = `${defaultTitle}`.replace(replaceNonSafeCharacters, ' ');
      }
    },
    [],
  );
};
